
import PropTypes from "prop-types";
import ScheduleCard from "@/pages/event_management/single_campaign/components/campaign_tabs/Schedule_Card";

const ScheduleTab = ({ eventName, schedules }) => {
  return (
    <div className="mt-4">
      {schedules.map((schedule) => (
        <ScheduleCard
          key={schedule.id}
          eventName={eventName}
          schedule={schedule}
        />
      ))}
    </div>
  );
};

ScheduleTab.propTypes = {
  schedules: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      address: PropTypes.string,
      location: PropTypes.string,
      timeRange: PropTypes.string,
    })
  ),
  eventName: PropTypes.string,
};

export default ScheduleTab;
